<template>
    <div class="container">
        <div class="row">
            <div class="col-md-5">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 dcs-label-cell">
                            Credit Card Information
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1 dcs-label-cell">
                            Number
                        </div>
                        <div class="col-md-4">
                            <input
                                name="number"
                                class="form-control"
                                placeholder="Card number"
                                v-model="cdetNumber"
                                v-card-focus
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1 dcs-label-cell">
                            Name
                        </div>
                        <div class="col-md-4">
                            <input
                                name="name"
                                class="form-control"
                                placeholder="Full name"
                                type="text"
                                v-model="cdetName"
                                v-card-focus
                            >
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1 dcs-label-cell">
                            Expiry
                        </div>
                        <div
                            class="col-md-4 dcs-narrow-cell1"
                            style="text-align:left;"
                        >
                            <input
                                name="expiry"
                                class="form-control"
                                placeholder="MM/YYYY"
                                type="tel"
                                v-model="cdetExpiry"
                                v-card-focus
                                style="display:inline;"
                            >
                            <span style="font-weight:bold;">(MM / YYYY)</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-1 dcs-label-cell">
                            CVC
                        </div>
                        <div class="col-md-4 dcs-narrow-cell1">
                            <input
                                name="cvc"
                                class="form-control"
                                placeholder="CVC"
                                type="tel"
                                v-model="cdetCvc"
                                v-card-focus
                            >
                        </div>
                    </div>
                    <div class="row dcs-cc-logo-row">
                        <div class="col-md-5 text-left">
                            <span>Accepted Payment Types:</span>
                            <img class="dcs-cc-logo" src="../assets/visa-logo.png"/>
                            <img class="dcs-cc-logo" src="../assets/mastercard-logo.png"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <card v-model="cardDetail" ref="cardWidget"></card>
            </div>
        </div>
        <div class="row">
            <div class="col-md-1"></div>
            <div class="col-md-6">
                <validate-warning
                    :warningActive="showCardError"
                    :validateFnc="cardErrorMsg"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import card from 'vue-credit-card';
    import validateWarning from "./ValidateWarning.vue";
    import { creditCardErrorMessage } from './Signup-lib';
    // import util from 'util';
    export default {
        name: "cardinfo",
        components: {
            card, validateWarning
        },
        data() {
            return {
            };
        },
        methods: {
        },
        mounted() {
            // console.log(`Our Cardinfo was mounted.`);
            let cardTypes = (((this.$refs.cardWidget || {}).options || {}).cardTypes || []);
            if (cardTypes.length > 0) {
                // console.log(`  Going to filter cardTypes. ${JSON.stringify(cardTypes)} `);
                let newCardTypes = cardTypes.filter(ct => ['mastercard', 'visa'].includes(ct));
                this.$refs.cardWidget.options.cardTypes = newCardTypes;
            }
        },
        computed: {
            cdetNumber: {
                get() {
                    return this.$store.state.signupFormData.cardDetail.number;
                },
                set(value) {
                    // console.log("Changing Number: and err currently " + this.showCardError());
                    this.$store.dispatch('CREDIT_CARD_DETAIL', { number: value.replace(/[^0-9]/g, '') });
                }
            },
            cdetName: {
                get() {
                    return this.$store.state.signupFormData.cardDetail.name;
                },
                set(value) {
                    this.$store.dispatch('CREDIT_CARD_DETAIL', { name: value });
                }
            },
            cdetExpiry: {
                get() {
                    return this.$store.state.signupFormData.cardDetail.expiry;
                },
                set(value) {
                    this.$store.dispatch('CREDIT_CARD_DETAIL', { expiry: value });
                }
            },
            cdetCvc: {
                get() {
                    return this.$store.state.signupFormData.cardDetail.cvc;
                },
                set(value) {
                    this.$store.dispatch('CREDIT_CARD_DETAIL', { cvc: value });
                }
            },
            cardDetail: function () {
                let cardDetailsFromState = this.$store.state.signupFormData.cardDetail;
                return { ...cardDetailsFromState };
            },
            showCardError: function () {
                return (this.$store.state.cardErrorState);
            },
            cardErrorMsg() {
                return creditCardErrorMessage(this.$store.state.signupFormData.cardDetail);
            }
        }
    };
</script>

<style>
    .dcs-label-cell {
        text-align: left;
        line-height: 36px;
        font-weight: 600;
        font-size: 120%;
    }
    .dcs-narrow-cell1 input {
        width: 10em;
    }
    .dcs-cc-logo-row {
        margin-top: 12px;
    }
    .dcs-cc-logo {
        height: 40px;
    }
</style>



// WEBPACK FOOTER //
// src/components/CardInfo.vue